// extracted by mini-css-extract-plugin
export var primary = "Link-module__primary___fT0c3";
export var secondary = "Link-module__secondary___EPiaw";